import { createReducer } from 'src/helpers/reducer';
import { ICardsState, ILoadDataSuccessPayload } from './types';
import actionsTypes from './actionTypes';

const initState: ICardsState = {
  credits: undefined,
  isLoading: false,
  total: 0,
};

function onLoadCreditsRequest(state: ICardsState): ICardsState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadCreditsSuccess(state: ICardsState, { payload }: { payload: ILoadDataSuccessPayload }): ICardsState {
  const { credits, total, filteredTotal } = payload;

  return {
    ...state,
    credits,
    total,
    filteredTotal,
    isLoading: false,
  };
}

function onLoadCreditsError(state: ICardsState) {
  return {
    ...state,
    isLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.LOAD_CREDITS_REQUEST]: onLoadCreditsRequest,
  [actionsTypes.LOAD_CREDITS_SUCCESS]: onLoadCreditsSuccess,
  [actionsTypes.LOAD_CREDITS_ERROR]: onLoadCreditsError,
});
